import allUrl from "../api/allUrl";
import { post, get, postRaw } from "../api/service/services";
// 获取城市
export const getCity = () => {
  return new Promise((resolve, reject) => {
    post(
      allUrl.register.getRegnData,
      {},
      {
        "Content-Type": "application/json;charset=UTF-8",
      }
    )
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let data = JSON.parse(res.data);
          let newData = childrenVal(data, ["code", "name"]);
          resolve(newData);
        } else {
        }
      })
      .catch((error) => {});
  }).then((data) => {
    return data;
  });
};
function childrenVal(data, obj) {
  data.length > 0 &&
    data.map((item) => {
      item.value = item[obj[0]];
      item.label = item[obj[1]];
      if (item.children && item.children.length > 0) {
        childrenVal(item.children, obj);
      }
    });
  return data;
}
